import React from 'react';
import { connect } from 'react-redux';
import { CustomPropTypes } from '@beef/react';
import { Flex } from '@fttb/common';
import PropTypes from 'prop-types';
import { TariffBenefitsGrid, TariffBenefitsItem, TariffBg, TariffButton, TariffCard, TariffDescription, TariffGift, TariffImage, TariffName, TariffParameters, TariffPrice, TariffTags, TariffValue, TariffValueGroupHeading, TariffValueGroups, TariffValues } from "../../../TariffsBlock/components";
import { getPopularTariffAlias } from "../../../../store/blocks/checkAddress/selectors";
import { CurrentTariffProvider } from "../../../../store/blocks/tariffs/tariffSelectors";
export var _PopularTariff = function _PopularTariff(_ref) {
  var className = _ref.className,
    tariffId = _ref.tariffId;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-PopularTariff"
  }, /*#__PURE__*/React.createElement(CurrentTariffProvider, {
    value: tariffId
  }, /*#__PURE__*/React.createElement(TariffCard.Link, null, /*#__PURE__*/React.createElement(TariffCard.Section, {
    overlay: /*#__PURE__*/React.createElement(TariffBg, null, /*#__PURE__*/React.createElement(TariffImage, {
      "data-t-id": "components-PopularTariff"
    })),
    side: "top"
  }, /*#__PURE__*/React.createElement(Flex, {
    className: "mar-b-s",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(TariffName, {
    "data-t-id": "components-PopularTariff"
  }), /*#__PURE__*/React.createElement(TariffTags, {
    className: "mar-l-xs"
  })), /*#__PURE__*/React.createElement(TariffValueGroups, null, /*#__PURE__*/React.createElement(TariffValueGroupHeading, {
    className: "mar-b-xs",
    "data-t-id": "components-PopularTariff"
  }), /*#__PURE__*/React.createElement(TariffValues, {
    className: "mar-b-xs"
  }, /*#__PURE__*/React.createElement(TariffValue, {
    className: "mar-b-2xs",
    "data-t-id": "components-PopularTariff"
  })))), /*#__PURE__*/React.createElement(TariffCard.Section, {
    side: "bottom"
  }, /*#__PURE__*/React.createElement(TariffBenefitsGrid, {
    className: "mar-b-m mar-t-2xs",
    wrap: "wrap"
  }, /*#__PURE__*/React.createElement(TariffBenefitsItem, {
    "data-t-id": "components-PopularTariff"
  })), /*#__PURE__*/React.createElement(TariffParameters, {
    className: "mar-b-s"
  }), /*#__PURE__*/React.createElement(TariffDescription, {
    className: "mar-b-s"
  }), /*#__PURE__*/React.createElement(TariffCard.Spacer, null), /*#__PURE__*/React.createElement(TariffGift, {
    className: "mar-b-m"
  }), /*#__PURE__*/React.createElement(Flex, {
    className: "mar-t-s",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(TariffPrice, {
    "data-t-id": "components-PopularTariff"
  }), /*#__PURE__*/React.createElement(TariffButton, {
    isPopular: true
  }))))));
};
_PopularTariff.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  tariffId: CustomPropTypes.id
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    tariffId: getPopularTariffAlias(state)
  };
};
export var PopularTariff = connect(mapStateToProps)(_PopularTariff);